module.exports = __webpack_public_path__ + "img/zuhe3.37236416.png";